function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M11.535 18.245l-4.207 2.211c-.489.257-1.094.07-1.35-.42-.103-.194-.138-.417-.101-.634l.803-4.684c.056-.325-.052-.656-.287-.885l-3.404-3.318c-.395-.385-.403-1.018-.018-1.414.154-.157.355-.26.573-.292l4.703-.683c.326-.047.607-.252.753-.547l2.103-4.262c.245-.495.844-.699 1.34-.454.197.097.356.257.454.454L15 7.579c.146.295.427.5.753.547l4.703.683c.547.08.926.587.846 1.134-.031.217-.134.419-.291.572l-3.404 3.318c-.235.23-.343.56-.287.885l.803 4.684c.093.544-.272 1.061-.816 1.155-.217.037-.44.002-.635-.1l-4.207-2.212c-.291-.154-.639-.154-.93 0z"
});

var SvgIconStarFill = function SvgIconStarFill(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconStarFill, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-star-fill.53a7761a.svg";
export { ForwardRef as ReactComponent };